/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__IdInputs */

const en__field__id = /** @type {(inputs: _Field__IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

/**
* | output |
* | --- |
* | "ID" |
*
* @param {_Field__IdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const _field__id = /** @type {((inputs?: _Field__IdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__IdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field__id(inputs)
});